<span class="homeCardAlias">{{ getFormattedAliasNumber(alias)}}</span>